import KyMethod from "@repositories/KyMethod"

interface ShareLinkBody {
  alias?: string
  type: "direct"
  password?: null
  active: true
  expires_at?: Date
  activates_at?: Date
  utm?: string
  domain_id?: null
  title?: string
  description?: string
  pixels?: any[]
  groups?: any[]
  rules?: any[]
  long_url: string
}

export default class CourseDetailRepositories extends KyMethod {
  protected async getRawCourseDetail(slug: string) {
    return this._getData(`/courses/${slug}`)
  }

  protected async getRawReview(courseId: string, query: any) {
    return this._getData(`/user/courses/${courseId}/review`, query)
  }

  protected async checkRawOrder(courseId: string) {
    return this._getProtectedData(`/order/${courseId}/check`)
  }

  protected async getRawShareLink(body: ShareLinkBody) {
    return this._protectedExternalCrudMethod("https://harisenin.link/api/v1/link", {
      body,
      method: "post",
      token: process.env.LINK_TOKEN || process.env.HARISENIN_LINK_TOKEN || "",
    })
  }
}
